import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, Directive } from '@angular/core';

const MAX_VALUE: number = 100;

@Directive()
export abstract class ImageSliderComponent {

  @ViewChild('container') private container: ElementRef; // TODO MIG is staic true OK?
  @ViewChild('handle') private handle: ElementRef; // TODO MIG is staic true OK?

  @Input() public value: number = 50;
  @Output() public valueChange: EventEmitter<number> = new EventEmitter<number>();

  private static findOffset(element: HTMLElement): {x: number, y: number} {
    const offset: { x: number, y: number } = { x: 0, y: 0 };
    if (!element.offsetParent) {
      return offset;
    }

    do {
      offset.x = offset.x + element.offsetLeft;
      offset.y = offset.y + element.offsetTop;

      element = <HTMLElement> element.offsetParent;
    } while (element);

    return offset;
  }

  public get handlePosition(): string {
    return `${MAX_VALUE - this.value}%`;
  }

  private ngAfterViewInit(): void {
    this.handle.nativeElement.addEventListener('touchmove', this.onTouchMove.bind(this));
    this.handle.nativeElement.addEventListener('mousemove', this.onMouseMove.bind(this));
    this.container.nativeElement.addEventListener('touchmove', this.onTouchMove.bind(this));
    this.container.nativeElement.addEventListener('mousemove', this.onMouseMove.bind(this));
    this.container.nativeElement.addEventListener('click', this.onClick.bind(this));
  }

  private onTouchMove(event: TouchEvent): void {
    const containerRef: HTMLElement = this.container.nativeElement;
    const touch: Touch = event.touches[0];

    const offset: {x: number, y: number} = ImageSliderComponent.findOffset(containerRef);

    const y: number = touch.pageY - offset.y;

    let percentage: number = Math.floor((y / containerRef.clientHeight) * MAX_VALUE);
    percentage = Math.min(Math.max(percentage, 0), MAX_VALUE);
    this.value = MAX_VALUE - percentage;
    this.valueChange.emit(this.value);

    event.preventDefault();
  }

  private onMouseMove(event: MouseEvent): void {
    if (event.buttons === 1) {
      const containerRef: HTMLElement = this.container.nativeElement;

      const offset: {x: number, y: number} = ImageSliderComponent.findOffset(containerRef);

      const y: number = event.pageY - offset.y;

      let percentage: number = Math.floor((y / containerRef.clientHeight) * MAX_VALUE);
      percentage = Math.min(Math.max(percentage, 0), MAX_VALUE);
      this.value = MAX_VALUE - percentage;
      this.valueChange.emit(this.value);
    }

    event.preventDefault();
  }

  private onClick(event: MouseEvent): void {
    const containerRef: HTMLElement = this.container.nativeElement;

    const offset: {x: number, y: number} = ImageSliderComponent.findOffset(containerRef);

    const y: number = event.pageY - offset.y;

    let percentage: number = Math.floor((y / containerRef.clientHeight) * MAX_VALUE);
    percentage = Math.min(Math.max(percentage, 0), MAX_VALUE);
    this.value = MAX_VALUE - percentage;
    this.valueChange.emit(this.value);
  }
}
